import UserRepo from '../repository/user';

class User { // eslint-disable-line fp/no-class
  data = null;

  setData(data) {
    this.data = data;
  }

  getData() {
    return this.data;
  }

  async ping() {
    const result = await UserRepo.fetch();
    this.setData(result.data);
    return result;
  }

  requiresLogin() {
    return this.data === null || !this.data.email;
  }
}

export default new User();
